import { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "../Common/data";

export default function useWishlist() {
  const [wishlistIds, setWishlistIds] = useState(() => {
    const stored = localStorage.getItem("wishlistIds");
    return stored ? JSON.parse(stored) : [];
  });

  const token = localStorage.getItem("token");

  const isInWishlist = (hotelId) => wishlistIds.includes(hotelId);

  const addToWishlist = async (hotelId) => {
    try {
      await axios.post(`${baseUrl}/api/wishlist/add`, { hotelId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const updated = [...wishlistIds, hotelId];
      setWishlistIds(updated);
      localStorage.setItem("wishlistIds", JSON.stringify(updated));
    } catch (err) {
      console.error("Error adding to wishlist:", err);
    }
  };

  const removeFromWishlist = async (hotelId) => {
    try {
      await axios.delete(`${baseUrl}/api/wishlist/remove`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { hotelId }
      });
      const updated = wishlistIds.filter(id => id !== hotelId);
      setWishlistIds(updated);
      localStorage.setItem("wishlistIds", JSON.stringify(updated));
    } catch (err) {
      console.error("Error removing from wishlist:", err);
    }
  };

  const toggleWishlist = async (hotelId) => {
    if (isInWishlist(hotelId)) {
      await removeFromWishlist(hotelId);
    } else {
      await addToWishlist(hotelId);
    }
  };

  return {
    wishlistIds,
    isInWishlist,
    addToWishlist,
    removeFromWishlist,
    toggleWishlist
  };
}
